import { render, staticRenderFns } from "./StatsStatisticsTable.vue?vue&type=template&id=1721442f&scoped=true&"
import script from "./StatsStatisticsTable.vue?vue&type=script&lang=ts&"
export * from "./StatsStatisticsTable.vue?vue&type=script&lang=ts&"
import style0 from "./StatsStatisticsTable.vue?vue&type=style&index=0&id=1721442f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1721442f",
  null
  
)

export default component.exports